import { REFUND_EMAILS, UNVERIFIED, VERIFIED } from './constants';

export const filterRefundEmails = data => {
  const targetObjectId = REFUND_EMAILS;

  const targetObject = data.find(obj => obj.id === targetObjectId);

  let deletedEmails = [];
  const statusArray = [VERIFIED, UNVERIFIED];
  if (targetObject && Array.isArray(targetObject.emails)) {
    deletedEmails = targetObject.emails.filter(
      item => !statusArray.includes(item.status),
    );
    targetObject.emails = targetObject.emails.filter(item =>
      statusArray.includes(item.status),
    );
  }
  return { data, deletedEmails };
};
